import { getMomentDate } from '../utils/commonUtils';
import { COLLABORATOR_REPORT, PAGINATION } from '../constants/Define';
import moment from 'moment';
export default class ReportBtbUseRoom {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        // this.pageIndex = data.pageIndex || PAGINATION.pageIndex;
        // this.pageSize = data.pageSize || PAGINATION.pageSize;
        // this.totalCount = data.totalCount || 0;
        // this.totalPage = Math.ceil(parseInt(data.totalCount || 0) / parseInt(2));
        // this.startDate = data.startDate ? moment.utc(data.startDate) : '';
        // this.endDate = data.startDate ? moment.utc(data.endDate) : '';
        // this.orderBy = data.orderBy;
        // this.orderByDesc = data.orderByDesc;
        this.items = data.data && data.data.map(item => new ReportBtbUseRoomItem(item));
    }

}

export class ReportBtbUseRoomItem {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.date = data.date;
        this.detailRoomType = data.details && data.details.map(item=> new DetailRoomType(item))
    }
}

export class DetailRoomType {
    constructor(data={}){
        this.setData(data)
    }

    setData(data={}){
        this.roomTypeId = data.roomTypeId;
        this.roomTypeCode = data.roomTypeCode;
        this.soldCount = data.soldCount;
        this.deducted = data.deducted;
        this.hardblock = data.hardblock;
        this.available = data.available;
    }
}